import styled from 'styled-components';
import { connect } from 'react-redux';
import Swal from 'sweetalert2';

import Modal from '../../../../shared/Modal';
import { ManageAccess } from '../../../../shared/ManageAccess/ManageAccess.jsx';
import { PlanLeftSectionTilesWrapper } from './StyledComponents';
import { SmallTileComponent } from '../../../../shared/SmallTile';
import TileCard from './TileCard.jsx';
import { EmptyDigestPlaceholder } from '../../../../shared/TileDigest/EmptyDigestPlaceholder.jsx';

const publishManageAccessClick = () => {
  Modal({
    component: <ManageAccess onClose={() => Swal.close()} />,
    width: '394px',
    padding: '0px',
  });
};

const EmptyTilesWrapper = styled.div`
  margin: 0 0 16px;
`;

const SuggestedTilesWrapper = styled.div`
  margin: 0 16px 16px 0;
`;

const MAX_EMPTY_TILES_COUNT = 7;

const SuggestedTilesContainer = ({ tiles, activeTab }) => {
  const suggestedTilesState = 'user_submitted';
  const suggestedTiles = tiles[suggestedTilesState].tiles;

  const EmptyTiles = () =>
    [...Array(MAX_EMPTY_TILES_COUNT - suggestedTiles.length).keys()].map(
      (_, i) => (
        <EmptyTilesWrapper key={i}>
          <EmptyDigestPlaceholder />
        </EmptyTilesWrapper>
      ),
    );

  return (
    <PlanLeftSectionTilesWrapper active={activeTab === 'suggested'}>
      <a href="#suggestion_box_manage_access">
        <TileCard
          color="primary.100"
          borderColor="black.10"
          className="js-suggestion-box-manage-access"
          handleClick={publishManageAccessClick}
          icon="fa-light fa-user-group fa-xl"
          text="Manage Access"
        />
      </a>
      {suggestedTiles.map(tileProps => (
        <SuggestedTilesWrapper key={tileProps.id}>
          <SmallTileComponent {...tileProps} currentTab="user_submitted" />
        </SuggestedTilesWrapper>
      ))}
      <EmptyTiles />
    </PlanLeftSectionTilesWrapper>
  );
};

const mapStateToProps = state => ({
  tiles: state.tiles.tiles,
  dndContext: state.dndContext,
});

export { SuggestedTilesContainer };

export default connect(mapStateToProps)(SuggestedTilesContainer);
